import { useMemo } from 'react';
import { z } from 'zod';
import { useTranslation } from 'react-i18next';
import { buildZodSchema } from 'redesign';
import { DocumentModel } from '@types';

export const useCreateIssueDocumentFormSchema = (
  documentModelsResponse: DocumentModel,
  selectedDocumentType: string
) => {
  const { t } = useTranslation(['hq-screen-specific']);
  const selectedSchema = documentModelsResponse[selectedDocumentType] ?? {
    actions: { issue: { items: [], rules: [] } },
  };

  const formSchema = useMemo(() => {
    const flexWorkerErrorMessage = t('flex_worker_select_section.validation.required', {
      ns: 'hq-screen-specific',
    });

    const baseSchema = z.object({
      documentType: z.string().min(1, {
        message: t('document_form.select_document_type', {
          ns: 'hq-screen-specific',
        }),
      }),
      flexWorkerOption: z.object(
        {
          value: z.string().uuid({ message: flexWorkerErrorMessage }),
          label: z.string(),
        },
        {
          message: flexWorkerErrorMessage,
        }
      ),
      language: z.string().optional(),
    });

    return buildZodSchema(
      selectedSchema.actions.issue.items,
      selectedSchema.actions.issue.rules,
      (dynamicSchema) => baseSchema.merge(dynamicSchema)
    );
  }, [selectedDocumentType, documentModelsResponse, t]);

  return formSchema;
};
